import React from 'react';
import ReactDOM from 'react-dom/client';
import { SpeedInsights } from '@vercel/speed-insights/react';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import Meta from './components/SEO/Meta';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <SpeedInsights/>
      <Meta/>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
